import { createContext, useContext } from "react";

export enum MobileCredibilityBadgePlacement {
  CONTROL = 0,
  HERO = 1,
  BELOW_HERO = 2,
}

export const MobileCredibilityBadgePlacementContext = createContext(MobileCredibilityBadgePlacement.CONTROL);

export const useMobileCredibilityBadgePlacement = (): MobileCredibilityBadgePlacement =>
  useContext(MobileCredibilityBadgePlacementContext);
